// import { apiCheckEmail } from 'app/api/users';

import { addMethod, string } from 'yup';

export const getEmailValidation = (currentEmail?: string) => {
  return string()
    .trim()
    .required('Email is required')
    .email('Email is invalid')
    .test(/* name */ 'unique-email', /* failure message */ 'This email is already taken', (value: string) => {
      if (currentEmail && value === currentEmail) {
        return true;
      }

      const schema = string().trim().required('Email is required').email('Email is invalid');

      // if (schema.isValidSync(value)) {
      //   return apiCheckEmail({ email: value })
      //     .then((resp) => resp)
      //     .catch(() => true);
      // } else {
      //   return false;
      // }
    });
};

export function yupCustomEmailValidation() {
  addMethod(string, 'email', function (message) {
    return this.matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      {
        name: 'email',
        message,
        excludeEmptyString: true,
      }
    );
  });
}
